module.exports = __webpack_public_path__ + "img/icn_entrega_call.9ff6524e.svg";